import { TableHeadingSorting } from '@/components/atom/TableHeadingSortable';
import { FC, useMemo, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { Pagination } from '../../molecule/Pagination';
import FulfillOrderModal from '../modals/FulfillOrderModal';
import { MarketOrder } from './MarketOrder';
import { ExchangeOrder } from '@/constants/types';
import { marketOrdersAtom } from '@/state/app';
import { sortByKey } from '@/utils/common';
import { ethers } from 'ethers';

export enum SortParams {
    _id = '_id',
    Name = 'tokenName',
    Amount = 'amount',
    Discount = 'fee',
    APY = 'APY',
    Unbonding = 'Unbonding Time',
}

export const MarketOrderTable: FC = () => {
    const marketOrders = useRecoilValue(marketOrdersAtom);
    const [currentOrder, setCurrentOrder] = useState<number | null>(null);

    const [state, setState] = useState<{ sort: SortParams; isAscending: boolean }>({
        sort: SortParams._id,
        // filters
        isAscending: false,
    });

    const filteredOrders = useMemo(() => {
        // Filter inactive orders
        let filtered = Object.values(marketOrders.orders).filter((x) => x.canFulfill);

        // Apply filter e.g.
        // const filterAmount = ethers.utils.parseEther('0.001');
        // filtered = filtered.filter(x => x.amountValue.gte(filterAmount));

        return state.sort == SortParams._id ? filtered : sortByKey([...filtered], state.sort, !state.isAscending);
    }, [marketOrders.update, state.sort, state.isAscending]);

    const handleSortClick = (type: SortParams) => {
        setState((previous) => ({ ...previous, sort: type, isAscending: !state.isAscending }));
    };

    return (
        <div className="flex flex-col min-h-[512px] relative items-center">
            <div className="grid w-full grid-cols-7 mb-2">
                <TableHeadingSorting
                    title="Token"
                    id={SortParams.Name}
                    onSortClick={handleSortClick}
                    current={state.sort}
                    isAscending={state.isAscending}
                />
                <TableHeadingSorting
                    title="Amount"
                    id={SortParams.Amount}
                    onSortClick={handleSortClick}
                    current={state.sort}
                    isAscending={state.isAscending}
                />
                <TableHeadingSorting title="Partial" />
                <TableHeadingSorting
                    title="Discount"
                    id={SortParams.Discount}
                    onSortClick={handleSortClick}
                    current={state.sort}
                    isAscending={state.isAscending}
                />
                {/*<TableHeadingSorting*/}
                {/*    title="APY"*/}
                {/*    id={SortParams.APY}*/}
                {/*    onSortClick={handleSortClick}*/}
                {/*    current={state.sort}*/}
                {/*    isAscending={state.isAscending}*/}
                {/*/>*/}
                {/*<TableHeadingSorting*/}
                {/*    title="Unbonding Time"*/}
                {/*    id={SortParams.Unbonding}*/}
                {/*    onSortClick={handleSortClick}*/}
                {/*    current={state.sort}*/}
                {/*    isAscending={state.isAscending}*/}
                {/*/>*/}
            </div>
            <Pagination
                items={filteredOrders}
                content={(order: ExchangeOrder) => (
                    <MarketOrder
                        key={order._id}
                        orderId={order._id}
                        fulfillOrder={(order: ExchangeOrder) => setCurrentOrder(order._id)}
                    />
                )}
                variant={'marketplace'}
                pageSize={10}
            />
            {!!currentOrder && (
                <FulfillOrderModal orderId={currentOrder} isVisible={true} onClose={() => setCurrentOrder(null)} />
            )}
        </div>
    );
};
